// DashboardHome.jsx
import React from 'react';
import { Text } from '@mantine/core';
import { useSelector } from 'react-redux';

function DashboardHome() {

  const user = useSelector((state) => state.auth.user);
 
  
  return (
    <div>
      <Text size="xl" >
      Welcome to the Dashboard{user ? `, ${user.username}` : '!' }
      </Text>
    </div>
  );
}

export default DashboardHome;
